import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-business-flat-rates',
  templateUrl: './business-flat-rates.component.html',
  styleUrls: ['./business-flat-rates.component.scss']
})
export class BusinessFlatRatesComponent implements OnInit, OnDestroy {

  constructor() {
  }

  ngOnInit() {
    const element = document.getElementById('flatSip');
    element.classList.add('active');
  }

  ngOnDestroy() {
    const element = document.getElementById('flatSip');
    element.classList.remove('active');
  }

}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/business-flat-rates/business-flat-rates.component.ts